"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectIpRefundRequestSchema = exports.IP_REFUND_REQUEST_STATUSES = exports.IP_REFUND_APPROVAL_THRESHOLD_PAISE = exports.recordIpRefundSchema = void 0;
const zod_1 = require("zod");
/** IP manual refund contract — desk, 2026-09-24. */
exports.recordIpRefundSchema = zod_1.z.object({
    /** Integer paise, positive. The server re-checks this against the LIVE refundable balance regardless. */
    amount: zod_1.z.number().int().positive(),
    mode: zod_1.z.string().min(1).max(50),
    remarks: zod_1.z.string().max(1000).optional(),
});
/**
 * THE APPROVAL THRESHOLD — desk, 2026-10-09: "refund rule above 3000, Lathamani should approve".
 *
 * A refund of MORE than this (strictly) is not posted when it is entered: it becomes a request that
 * waits for someone holding `ip:refund:approve`. A refund of exactly this amount or less posts at once.
 * Integer paise, like every amount on the wire. ONE constant, read by the server (which enforces it) and
 * by the Refund tab (which only tells the clerk what will happen) — change it here and nowhere else.
 */
exports.IP_REFUND_APPROVAL_THRESHOLD_PAISE = 300_000;
exports.IP_REFUND_REQUEST_STATUSES = ['REQUESTED', 'APPROVED', 'REJECTED'];
/** Rejecting needs a reason the requester can read; approving needs nothing (the amount is already on the request). */
exports.rejectIpRefundRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().min(3, 'Give a reason for rejecting this refund.').max(500),
});
//# sourceMappingURL=ip-refund.schema.js.map